import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

function LandingPage() {
  const fireflies = useMemo(() => {
    // Create a grid for more uniform distribution
    const gridSize = 5; // 5x5 grid
    const cellWidth = 100 / gridSize;
    const cellHeight = 100 / gridSize;
    
    const small = Array.from({ length: 20 }).map((_, index) => {
      // Distribute across grid cells
      const gridRow = Math.floor(index / gridSize);
      const gridCol = index % gridSize;
      
      // Add some randomness within each grid cell
      const top = `${gridRow * cellHeight + (Math.random() * 0.6 + 0.2) * cellHeight}%`;
      const left = `${gridCol * cellWidth + (Math.random() * 0.6 + 0.2) * cellWidth}%`;
      const delay = `${(Math.random() * 5).toFixed(2)}s`;
      const duration = `${(15 + Math.random() * 10).toFixed(2)}s`;
      const swirl = Math.random() > 0.6;
      return { top, left, delay, duration, swirl, size: 4 };
    });
    
    const big = Array.from({ length: 5 }).map((_, index) => {
      // Distribute big fireflies across different grid positions
      const gridRow = Math.floor(index / 3);
      const gridCol = index % 3;
      
      // Add some randomness within each grid cell
      const top = `${gridRow * cellHeight + (Math.random() * 0.6 + 0.2) * cellHeight}%`;
      const left = `${gridCol * cellWidth + (Math.random() * 0.6 + 0.2) * cellWidth}%`;
      const delay = `${(Math.random() * 5).toFixed(2)}s`;
      const duration = `${(15 + Math.random() * 10).toFixed(2)}s`;
      const swirl = Math.random() > 0.6;
      return { top, left, delay, duration, swirl, size: 8 };
    });
    return [...small, ...big];
  }, []);

  return (
    <section className="hero home">
      <div className="container">
        <h1>Sean David Robinson</h1>
        <p>Author</p>
      </div>
      
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="home-book-section">
          <div className="home-book-image">
            <img src="/images/the-door-in-penrose-forest-3d-web-transparent.png" alt="The Door in Penrose Forest" />
          </div>
          
          <div className="home-book-content">
            <h2 className="home-book-title">The Door in Penrose Forest</h2>
            <p className="home-book-availability">Coming June 23, 2026</p>
            <p className="home-book-tagline">A man returns to his strange hometown twenty years after his mother climbed a staircase in the wilderness and disappeared in this speculative mystery where <em>We Used to Live Here</em> meets <em>The Midnight Library</em>.</p>
            
            <div className="home-buy-section">
              <h3>Preorder Now:</h3>
              <div className="home-retailer-grid">
                <div className="home-retailer-row home-retailer-row-local">
                  <a href="https://malaprops.com/book/9798892425957" className="home-retailer-btn" target="_blank" rel="nofollow noopener noreferrer">
                    Malaprop's
                  </a>
                  <a href="https://bookshop.org/a/2186/9798892425957?prhc=PRHEFFDF5A7F1" className="home-retailer-btn" target="_blank" rel="nofollow noopener noreferrer">
                    Bookshop
                  </a>
                  <a href="https://www.hudsonbooksellers.com/book/9798892425957?utm_source=prh&utm_medium=affiliate&utm_term=301&utm_content=PRHEFFDF5A7F1--9798892425957&utm_campaign=9798892425957" className="home-retailer-btn" target="_blank" rel="nofollow noopener noreferrer">
                    Hudson Booksellers
                  </a>
                  <a href="https://www.powells.com/book/-9798892425957?utm_source=randomhouse&utm_campaign=randomhouse&utm_content=PRHEFFDF5A7F1--9798892425957" className="home-retailer-btn" target="_blank" rel="nofollow noopener noreferrer">
                    Powell's
                  </a>
                </div>
                <div className="home-retailer-row home-retailer-row-chains">
                  <a href="https://www.amazon.com/gp/product/B0FSCCQPB8?tag=randohouseinc7986-20" className="home-retailer-btn" target="_blank" rel="nofollow noopener noreferrer">
                    Amazon
                  </a>
                  <a href="https://www.anrdoezrs.net/click-8373827-11819508?sid=PRHEFFDF5A7F1&url=https://www.barnesandnoble.com/w/?ean=9798892425957" className="home-retailer-btn" target="_blank" rel="nofollow noopener noreferrer">
                    Barnes & Noble
                  </a>
                  <a href="https://www.tkqlhce.com/click-8373827-10747236?SID=PRHEFFDF5A7F1--9798892425957&url=https://www.booksamillion.com/p/9798892425957" className="home-retailer-btn" target="_blank" rel="nofollow noopener noreferrer">
                    Books-a-Million
                  </a>
                  <a href="https://goto.walmart.com/c/128773/565706/9383?subId1=PRHEFFDF5A7F1&veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fsearch%3Fquery%3D9798892425957" className="home-retailer-btn" target="_blank" rel="nofollow noopener noreferrer">
                    Walmart
                  </a>
                  <a href="https://goto.target.com/c/128773/81938/2092?subId1=PRHEFFDF5A7F1--9798892425957&u=https%3A%2F%2Fwww.target.com%2Fs%3FsearchTerm%3D9798892425957" className="home-retailer-btn" target="_blank" rel="nofollow noopener noreferrer">
                    Target
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {fireflies.map((pos, idx) => (
        <span
          key={idx}
          className={`firefly${pos.swirl ? ' swirl' : ''}${pos.size === 8 ? ' big' : ''}`}
          style={{
            top: pos.top,
            left: pos.left,
            animationDelay: pos.delay,
            animationDuration: pos.duration,
            opacity: 0.1
          }}
        />
      ))}
    </section>
  );
}

export default LandingPage; 